import { BlocksImageGalleryThumbnailItem } from 'blocks-nextjs/blocks-web-components/components/image-gallery-thumbnail-item/image-gallery-thumbnail-item';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatImageGalleryThumbnailItem = createComponent({
  react: React,
  tagName: 'cat-image-gallery-thumbnail-item',
  elementClass: BlocksImageGalleryThumbnailItem
});
